<template>
    <div v-if="localConfig">



        <div class="section">
            <span class="section-title">General Settings</span>
            <div class="form-group">
                <label>Schema Version: {{ localConfig.schemaVersion }}</label>
            </div>

            <div class="form-group">
                <label>Affiliate Code</label>
                <select v-model="localConfig.affiliateCode">
                    <option v-for="code in affiliationCodes" :key="code" :value="code">{{ code }}</option>
                </select>
            </div>

            <div class="form-group">
                <label>Site Name</label>
                <input type="text" v-model="localConfig.siteName" placeholder="Site Name" />
            </div>

            <div class="form-group">
                <label>Favicon URL</label>
                <input type="text" v-model="localConfig.favicon" placeholder="https://example.com/favicon.ico" />
            </div>

            <div class="form-group">
                <label>Logo URL</label>
                <input type="text" v-model="localConfig.logo" placeholder="https://example.com/logo-rect.png" />
            </div>


            <div class="form-group">
                <label><span>Domains (comma separated, e.g. <span class="accent">www.domain.com</span>, no <span
                            class="accent">https://</span>)</span></label>
                <input type="text" :value="localConfig.domains ? localConfig.domains.join(',') : ''"
                    @input="localConfig.domains = $event.target.value.split(',').map(d => d.trim()).filter(Boolean)"
                    placeholder="www.domain1.com,www.domain2.com" />
            </div>

            <div class="form-group form-group--no-margin">
                <label class="checkbox">
                    <input class="checkbox-input" type="checkbox" v-model="localConfig.showPoweredBy" />
                    <span class="checkbox-label">Show Powered By</span>
                </label>
            </div>

            <div class="form-group form-group--no-margin">
                <label class="checkbox">
                    <input class="checkbox-input" type="checkbox" v-model="localConfig.header.showHomeLink" />
                    <span class="checkbox-label">Show Home Link</span>
                </label>
            </div>

            <div class="form-group form-group--no-margin">
                <label class="checkbox">
                    <input class="checkbox-input" type="checkbox" v-model="localConfig.header.useDarkFont" />
                    <span class="checkbox-label">Use dark font in header</span>
                </label>
            </div>

            <div class="form-group form-group--no-margin">
                <label class="checkbox">
                    <input class="checkbox-input" type="checkbox" v-model="localConfig.footer.useDarkFont" />
                    <span class="checkbox-label">Use dark font in footer</span>
                </label>
            </div>

            <div class="form-group form-group--no-margin">
                <label class="checkbox">
                    <input class="checkbox-input" type="checkbox" v-model="localConfig.enableCoupons" />
                    <span class="checkbox-label">Allow Coupons </span>
                </label>
            </div>

        </div>

        <div class="section">
            <span class="section-title">Localization Settings</span>

            <div class="form-group">
                <label>Languages (comma separated)</label>
                <input type="text" v-model="languagesInput" @change="updateLanguages" placeholder="en,es,de" />
            </div>

            <div class="form-group">
                <label>Currencies (comma separated)</label>
                <input type="text" v-model="currenciesInput" @change="updateCurrencies" placeholder="EUR,USD,GBP" />
            </div>

            <div class="form-group">
                <label>Default Language</label>
                <select v-model="localConfig.localization.defaultLanguage">
                    <option v-for="lang in localConfig.localization.languages" :key="lang" :value="lang">{{ lang }}
                    </option>
                </select>
            </div>

            <div class="form-group">
                <label>Default Currency</label>
                <select v-model="localConfig.localization.defaultCurrency">
                    <option v-for="cur in localConfig.localization.currencies" :key="cur" :value="cur">{{ cur }}
                    </option>
                </select>
            </div>

        </div>

        <div class="section">
            <span class="section-title">Analytics Settings</span>


            <div class="form-group form-group--no-margin">
                <label class="checkbox">
                    <input class="checkbox-input" type="checkbox"
                        v-model="localConfig.thirdPartyTrackers.googleTagManager.enabled" />
                    <span class="checkbox-label">Custom Google Tag Manager</span>
                </label>
            </div>
            <div class="form-group" v-if="localConfig.thirdPartyTrackers.googleTagManager.enabled">
                <input type="text" v-model="localConfig.thirdPartyTrackers.googleTagManager.id"
                    placeholder="GTM-XXXXXX" />
            </div>

            <div class="form-group form-group--no-margin">
                <label class="checkbox">
                    <input class="checkbox-input" type="checkbox"
                        v-model="localConfig.thirdPartyTrackers.googleAnalytics.enabled" />
                    <span class="checkbox-label">Custom Google Analytics</span>
                </label>
            </div>
            <div class="form-group" v-if="localConfig.thirdPartyTrackers.googleAnalytics.enabled">
                <input type="text" v-model="localConfig.thirdPartyTrackers.googleAnalytics.id"
                    placeholder="UA-XXXXXX-X" />
            </div>

            <div class="form-group form-group--no-margin">
                <label class="checkbox">
                    <input class="checkbox-input" type="checkbox"
                        v-model="localConfig.thirdPartyTrackers.cookieBot.enabled" />
                    <span class="checkbox-label">Custom Cookie Bot</span>
                </label>
            </div>
            <div class="form-group" v-if="localConfig.thirdPartyTrackers.cookieBot.enabled">
                <input type="text" v-model="localConfig.thirdPartyTrackers.cookieBot.id" placeholder="CB-XXXXXX" />
            </div>

        </div>

        <div class="section">
            <span class="section-title">Email Settings</span>
            <div class="form-group">
                <label>From Name</label>
                <input type="text" v-model="localConfig.communication.email.fromName" placeholder="From Name" />
            </div>
            <div class="form-group">
                <label>From Email</label>
                <input type="text" v-model="localConfig.communication.email.fromEmail" placeholder="From Email" />
            </div>
            <div class="form-group">
                <label>Reply To Name</label>
                <input type="text" v-model="localConfig.communication.email.replyToName" placeholder="Reply To Name" />
            </div>
            <div class="form-group">
                <label>Reply To Email</label>
                <input type="text" v-model="localConfig.communication.email.replyToEmail"
                    placeholder="Reply To Email" />
            </div>
        </div>

        <div class="section">
            <span class="section-title">Theme Settings</span>

            <div class="form-group">
             <div v-for="(color, idx) in localConfig.colors" :key="'color-' + idx" 
                class="input-group">
                <span class="input-group__label">{{ color.key }}</span>
                <input type="text" v-model="color.value" placeholder="Value (e.g. #fff)" class="input-group__input" />
              </div>
            </div>
        </div>

        <div class="section">
            <span class="section-title">Search Mask</span>

            <div class="form-group">
                <label>CTA Radius</label>
                <input type="text" v-model="localConfig.cta.radius" placeholder="e.g. 8px" />
            </div>
            <div class="form-group">
                <label>CTA Font Color</label>
                <input type="text" v-model="localConfig.cta.fontColor" placeholder="#FFF" />
            </div>


            <div class="form-group">
                <label>Search Mask Background Color</label>
                <input type="text" v-model="localConfig.searchMask.backgroundColor" placeholder="#f0f0f0" />
            </div>

            <div class="form-group">
                <label>Search Mask Background Image</label>
                <input type="text" v-model="localConfig.searchMask.backgroundImage" placeholder="https://example.com/background.jpg" />
            </div>

            <div class="form-group">
                <label class="checkbox">
                    <input class="checkbox-input" type="checkbox" v-model="localConfig.searchMask.hideFilters" />
                    <span class="checkbox-label">Hide port filters</span>
                </label>
            </div>


            <div class="form-group">
                <label class="checkbox">
                    <input class="checkbox-input" type="checkbox" v-model="localConfig.searchMask.infoSectionFontColorWhite" />
                    <span class="checkbox-label">Use white font color in info section</span>
                </label>
            </div>

            <div class="form-group">
                <label>Popular Ports (comma separated)</label>
                <input type="text" v-model="popularPortsInput" @change="updatePopularPorts" placeholder="" />
            </div>

        </div>


        <div class="section">
            <span class="section-title">Social Media</span>

            <div class="form-group">
                <label>Facebook</label>
                <input type="text" v-model="localConfig.social.facebook" placeholder="Facebook URL" />
            </div>
            <div class="form-group">
                <label>TikTok</label>
                <input type="text" v-model="localConfig.social.tiktok" placeholder="TikTok URL" />
            </div>
            <div class="form-group">
                <label>Instagram</label>
                <input type="text" v-model="localConfig.social.instagram" placeholder="Instagram URL" />
            </div>
            <div class="form-group">
                <label>LinkedIn</label>
                <input type="text" v-model="localConfig.social.linkedin" placeholder="LinkedIn URL" />
            </div>
            <div class="form-group">
                <label>X (Twitter)</label>
                <input type="text" v-model="localConfig.social.x" placeholder="X (Twitter) URL" />
            </div>
        </div>
    </div>

</template>


<script>
import { COLOR_DEFINITIONS } from "../models/getDefaultWhitelabelConfiguration";

export default {
    name: "WhitelabelConfigForm",
    props: {
        affiliationCodes: {
            type: Array,
            required: false,
            default: () => []
        },
        config: {
            type: Object,
            required: true
        }
    },
    data: () => ({
        localConfig: undefined,
        languagesInput: '',
        currenciesInput: '',
        popularPortsInput: '',
        colorDefinitions: COLOR_DEFINITIONS,
    }),
    created() {
        this.localConfig = JSON.parse(JSON.stringify(this.config));
        this.currenciesInput = this.localConfig.localization.currencies.join(',');
        this.languagesInput = this.localConfig.localization.languages.join(',');
        this.popularPortsInput = this.localConfig.searchMask.popularPorts.join(',');
    },
    watch: {
        config: {
            deep: true,
            handler(newConfig) {
                if (JSON.stringify(this.localConfig) !== JSON.stringify(this.config)) {
                    this.localConfig = JSON.parse(JSON.stringify(newConfig));
                    this.currenciesInput = this.localConfig.localization.currencies.join(',');
                    this.languagesInput = this.localConfig.localization.languages.join(',');
                    this.popularPortsInput = this.localConfig.searchMask.popularPorts.join(',');
                }
            }
        },
        localConfig: {
            deep: true,
            handler() {
                if (JSON.stringify(this.localConfig) !== JSON.stringify(this.config)) {
                    this.$emit('onUpdate', this.localConfig);
                }
            }
        }
    },
    methods: {
        updateLanguages() {
            this.localConfig.localization.languages = this.languagesInput.split(',').map(l => l.trim()).filter(Boolean);
        },
        updateCurrencies() {
            this.localConfig.localization.currencies = this.currenciesInput.split(',').map(c => c.trim()).filter(Boolean);
        },
        updatePopularPorts() {
            this.localConfig.searchMask.popularPorts = this.popularPortsInput.split(',').map(p => p.trim()).filter(Boolean);
        },
    }
};
</script>

<style scoped></style>